import slinky from "jquery-slinky";

(function($) {
	let options = {
		title: false,
		resize: true
	};
	const slinky = $(".drilldown").slinky(options);
	// var imgUrl = $('.menu-item-has-children').find('span img').attr('src');
	// console.log(imgUrl);

	const header = $(".menuChild .header");
	const menuChild = $(".menuChild");
	const selectMenu = $("#menu-hovedmeny-1");

	$(".menuChild");
	// header.css('background-image', 'url(' + imgUrl + ')');
	// menuChild.append('<li><a href="#" class="back custom"><span>Tilbake</span></a></li>');
	// $('.back.custom');
	// header.prepend(`<div class="drilldownHeader">`);
	// header.append(`<img class="drilldownHeader__image" src='${test}'>`);
	// header.append(`</div>`);
})(jQuery);

